export default "__VITE_ASSET__CMZH2t3Z__"